import { useUser } from "@/utils/identity";
import MobileNavbarView from "./MobileNavbarView";
import useClientNavItems from "./useClientNavItems";
import useCoachNavItems from "./useCoachNavItems";

const COACH_MAX_BAR_SLOTS = 4;
const CLIENT_MAX_BAR_SLOTS = 5;

export default function MobileNavbar() {
    const user = useUser();

    return user.type === "coach" ? (
        <CoachMobileNavbar />
    ) : (
        <ClientMobileNavbar />
    );
}

function CoachMobileNavbar() {
    const items = useCoachNavItems();

    return <MobileNavbarView items={items} maxBarSlots={COACH_MAX_BAR_SLOTS} />;
}

function ClientMobileNavbar() {
    const items = useClientNavItems();

    return (
        <MobileNavbarView items={items} maxBarSlots={CLIENT_MAX_BAR_SLOTS} />
    );
}
